<template>
  <div class="pagination-container" v-if="pageList.length > 1">
    <a class="active pagination-item traverse-item" type="button" v-on:click="switchPage">Previous</a>
    <ul class="pagination">
      <li class="pagination-item {{ page.classList }}" v-for="page in pageList"
        v-bind:page="page.pageNumber"
        v-bind:key="page.pageNumber"
        v-on:click="switchPage"
      >
        {{ page.pageNumber }}
      </li>
    </ul>
    <a class="active pagination-item traverse-item" type="button" v-on:click="switchPage">Next</a>
  </div>
</template>

<script>
export default {
  components: {},
  props: [
    'category',
    'pageList',
  ],
  methods: {
    switchPage(event) {
      event.preventDefault();

      const pageText = event.target.innerText;
      const pageTotal = this.pageList[this.pageList.length - 1].pageNumber;

      let pageNumber = -1;

      // Check to see if we have a page seperator
      const currentPage = this.pageList.find((page) => (
        page.classList.includes('active')
      )).pageNumber;

      // Handle our previous, next, seperator, and regular links
      if (pageText === 'Previous') {
        if (currentPage !== 1) {
          pageNumber = currentPage - 1;
        } else {
          pageNumber = -1;
        }
      } else if (pageText === 'Next') {
        if (currentPage !== pageTotal) {
          pageNumber = currentPage + 1;
        } else {
          pageNumber = -1;
        }
      } else if (pageText === '...') {
        pageNumber = -1;
      } else {
        pageNumber = parseInt(event.target.getAttribute('page') || '-1', 10);
      }

      // forward to parent only if our next page is greater than 0
      if (pageNumber > 0) {
        this.$parent.switchPage(pageNumber, this.category);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .dark-theme {
    & .pagination-item {
      background-color: transparent;
      border: 1px solid white;
      color: white;

      &:hover,
      &.active {
        background-color: white;
        color: gray;
      }

      &.concat-item {
        color: white;
      }
    }
  }

  .pagination {
    display: flex;
    padding: 0;

    & > li {
      list-style-type: none;
    }
  }

  .pagination-container {
    align-items: center;
    display: flex;
    justify-content: center;
  }

  .pagination-item {
    appearance: none;
    background-color: transparent;
    border: 1px solid gray;
    color: gray;
    font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif;
    font-size: 14px;
    margin-right: 5px;
    padding: 5px 10px;
    text-decoration: none;

    &:hover {
      cursor: pointer;
    }

    &:hover,
    &.active {
      background-color: gray;
      color: white;

      & > button {
        color: white;
      }
    }

    &.concat-item {
      align-self: flex-end;
      background-color: transparent;
      border: none;
      padding: 0;

      &:hover {
        background-color: transparent;
        color: gray;
        cursor: default;
      }
    }

    & > button {
      color: gray;
      text-decoration: none;

      &:hover {
        text-decoration: none;
      }
    }
  }

  .traverse-item {
    font-weight: bold;
  }
</style>


// WEBPACK FOOTER //
// pagination.vue?399d2a31